module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "chapter",
    attrs: {
      "id": "ch5"
    }
  }, [_c('div', {
    staticClass: "chapterHead"
  }, [_c('p', {
    staticClass: "centerImage0"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/ch5.jpg",
      "width": "5%"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "pg-5"
    }
  }, [_vm._v("You think for a moment. Dr. Peebles obviously believes you’re someone else. But a trip through time sounds like a lot of fun. More fun than staring at crummy old bowls all day. And since you’ll return at the exact same time you left, you’ll still be able to find Denny and return to your parents before they know anything is wrong.")])]), _c('a', {
    attrs: {
      "id": "pg-5"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("On the other hand, Denny can get into a lot of trouble very fast. And your parents will blame "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("you")]), _vm._v(" if anything happens.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Make a decision now. Do you want to travel in time? Or should you look for your brother first?")])]), _c('p', {
    staticClass: "extractLetterText",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "pg-5"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("If you choose to volunteer for Dr. Peebles’s experiment, turn to ")])]), _c('span', {
    attrs: {
      "href": "#/e9780545841016_ch071",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("PAGE 71")])]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("If you think you’d better stay and look for Denny, turn to "), _c('span', {
    attrs: {
      "href": "#/e9780545841016_ch062",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("PAGE 62")])]), _vm._v(".")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c30d0284","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/e9780545841016_ch005.vue
// module id = 78
// module chunks = 0